/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { EditableCellDaily } from "components";
import { toPersianNum } from "utils/helpers";
import { EXPAND_LIST_DAILY_TYPE } from "utils/Constants";
import "../KitchenExpandList.scss";

const ExpandedRowDaily = ({
    food,
    defaultOrders,
    hubsCount,
    hubs,
    isClicked,
    handleLogChange,
    isDisabled,
    isUpdate,
    rowId,
    totalRows,
    tableType,
}) => {
    const { Items } = food;
    const haveAdditionalItems = hubsCount - Items ? Items.length : 0;
    const [totalColumns, setTotalColumns] = useState(0);
    const emptyCells = [];

    useEffect(() => {
        calcColumnsTotal();
    }, [Items]);

    if (haveAdditionalItems > 0) {
        for (let i = 0; i < haveAdditionalItems; i++) {
            emptyCells.push("");
        }
    }

    const handleDefaultFood = (food) => {
        const foods = [...defaultOrders];
        const foodindex = foods.findIndex(
            (item) =>
                food.hub_id === item.hub_id &&
                food.product_id === item.product_id
        );
        return foods[foodindex];
    };

    useEffect(() => {
        if (tableType === EXPAND_LIST_DAILY_TYPE.b2c) {
            if (Items) {
                const newItems = [...Items];
                const total = isUpdate
                    ? newItems.reduce(
                          (acc, item) => (acc += Number(item.qty_2)),
                          0
                      )
                    : newItems.reduce(
                          (acc, item) => (acc += Number(item.qty)),
                          0
                      );
                setTotalColumns(total);
            } else {
                setTotalColumns(0);
            }
        } else if (tableType === EXPAND_LIST_DAILY_TYPE.b2b) {
            if (Items) {
                const newItems = [...Items];
                const total = newItems.reduce(
                    (acc, item) => (acc += Number(item.b2b_stock)),
                    0
                );
                setTotalColumns(total);
            } else {
                setTotalColumns(0);
            }
        } else if (tableType === EXPAND_LIST_DAILY_TYPE.total) {
            if (Items) {
                const newItems = [...Items];
                const total = isUpdate
                    ? newItems.reduce(
                          (acc, item) =>
                              (acc += Number(item.qty_2 + item.b2b_stock)),
                          0
                      )
                    : newItems.reduce(
                          (acc, item) =>
                              (acc += Number(item.qty + item.b2b_stock)),
                          0
                      );
                setTotalColumns(total);
            } else {
                setTotalColumns(0);
            }
        }
    }, [tableType]);

    const calcColumnsTotal = () => {
        if (Items) {
            const newItems = [...Items];
            const total = isUpdate
                ? newItems.reduce((acc, item) => (acc += Number(item.qty_2)), 0)
                : newItems.reduce((acc, item) => (acc += Number(item.qty)), 0);
            setTotalColumns(total);
        } else {
            setTotalColumns(0);
        }
    };

    const logChangeRowValues = async (item, qty) => {
        handleLogChange(item, qty);
        calcColumnsTotal();
    };

    const getCurrentFood = (hubId) => {
        if (Items) {
            const currentFoodIndex = Items.findIndex(
                (item) => item.hub_id === hubId
            );
            return currentFoodIndex > -1 ? Items[currentFoodIndex] : null;
        } else {
            return null;
        }
    };

    return (
        <Fragment key={rowId}>
            {hubs.map((hub, index) => {
                if (getCurrentFood(hub.id)) {
                    return (
                        <td
                            className={`td ${isClicked ? "new-back" : " "}`}
                            key={index}
                        >
                            <EditableCellDaily
                                item={getCurrentFood(hub.id)}
                                handleLogChange={logChangeRowValues}
                                defaultFood={handleDefaultFood(
                                    getCurrentFood(hub.id)
                                )}
                                isDisabled={isDisabled}
                                cellId={index + 1}
                                rowId={rowId}
                                isUpdate={isUpdate}
                                totalCells={hubs.length}
                                totalRows={totalRows}
                                cellType={tableType}
                            />
                        </td>
                    );
                } else {
                    return (
                        <td className={`td ${isClicked ? "new-back" : ""}`}>
                            -
                        </td>
                    );
                }
            })}
            <td className="td">{toPersianNum(totalColumns, true)}</td>
        </Fragment>
    );
};

ExpandedRowDaily.propTypes = {
    food: PropTypes.object,
    hubs: PropTypes.array,
    hubsCount: PropTypes.number,
    handleLogChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    isUpdate: PropTypes.bool,
    submitMethod: PropTypes.string,
    rowId: PropTypes.number,
    totalRows: PropTypes.number,
};

export default ExpandedRowDaily;
